const Vue = require('vue')

Vue.component('validator', {
    props: {},
    data () {
        return {
            invalid: []
        }
    },
    ready () {
        this.$on('validator:wipe-for', (field) => {
            this.invalid = this.invalid.filter(_ => _.field !== field)
        })

        this.$on('validator:add-invalid', (message) => {
            this.invalid.push(message)
        })
    },
    watch: {
        invalid (newVal) {
        }
    },
    computed: {
        isValid () {
            return this.invalid.length < 1
        }
    },
    template: `<div><slot></slot></div>`
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/validator.js